export const DEFAULT_COLUMNS = [
  "channel",
  "geography",
  "product_hierarchy",
  "total_spend",
  "total_revenue",
  "total_roi",
  "total_roas",
  "total_units",
];
